import { icons } from "lucide-react";
import * as React from "react";

import { cn } from "~/utils";

import { Icon } from "./icon";

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  inputSize?: "sm" | "md" | "lg";
}

const inputSizes = {
  sm: "h-8",
  md: "h-10",
  lg: "h-12",
};

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, inputSize = "md", ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          `flex w-full rounded-sm border border-input bg-white px-3 py-2 file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:border-transparent focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-0 disabled:cursor-not-allowed disabled:opacity-50 ${
            inputSize === "sm" ? "text-xs" : "text-sm"
          } ${inputSizes[inputSize]}`,
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);
Input.displayName = "Input";

const InputWithIcon = React.forwardRef<
  HTMLInputElement,
  InputProps & {
    iconName: keyof typeof icons;
    iconSize: number;
    iconClassName?: string;
  }
>(({ className, type, iconName, iconSize, iconClassName, ...props }, ref) => {
  return (
    <div className="relative flex flex-1">
      <input
        type={type}
        className={cn(
          "flex h-10 w-full rounded-sm bg-white py-2 pl-8 pr-3 text-sm placeholder:text-muted-foreground focus-visible:border-transparent focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-0 disabled:cursor-not-allowed disabled:opacity-50",
          className,
        )}
        ref={ref}
        {...props}
      />
      <Icon
        size={iconSize}
        name={iconName}
        className={cn(
          "pointer-events-none absolute left-2 top-3",
          iconClassName,
        )}
      />
    </div>
  );
});
InputWithIcon.displayName = "InputWithIcon";

export { Input, InputWithIcon };
